import { CSSProperties } from 'react';
import { useBankLogo } from '../../hooks/useBankLogo';

interface BankLogoProps {
	bankName: string;
	style?: CSSProperties;
}

const BankLogo = ({ bankName, style }: BankLogoProps) => {
	const src = useBankLogo(bankName);

	const id = `${bankName}-logo`;
	const alt = `${bankName} logo`;
	return (
		<img
			id={id}
			className="bank-logo"
			alt={alt}
			src={src}
			style={{ width: '100%', height: '100%', borderRadius: '50%', ...style }}
		/>
	);
};

export default BankLogo;
